import script from "./platformManage.vue?vue&type=script&setup=true&lang=js"
export * from "./platformManage.vue?vue&type=script&setup=true&lang=js"

import "./platformManage.vue?vue&type=style&index=0&id=4b3f2d0c&lang=scss"

const __exports__ = script;

export default __exports__